import axios from 'axios'
import getCountryName from './CountryService'

type MailingData = {
  topic: string
  name: string
  company: string
  email: string
  phone: string
  message: string
  country: string
  source: string
  url: string
  referrer: string
}

type DetectSpamData = {
  action: string
  clientIP: string
  token?: string
}

export class MailingService {
  static async sendContactForm({
    topic, name, company, email, phone, message, country, source, url, referrer
  }: MailingData) {
    try {
      if (process.env.GATSBY_CONTACT_FORM_URL && process.env.GATSBY_PIPEDRIVE_API) {
        const messageWithTopic =  `Selected topic: ${topic} \n\n${message}`
        const data = {
          name,
          email,
          company,
          phone,
          message: messageWithTopic,
          country,
          source,
          url,
          referrer,
        }
  
        axios.post(process.env.GATSBY_PIPEDRIVE_API, {
          name: 'Krzysztof Zduńczyk',
          content: data,
          person: {
            name: data.name,
            email: data.email,
            phone: data.phone,
            country: getCountryName(data.country)
          },
          marketingAgreement: false,
          inbound: localStorage.getItem('inbound') || 'Inbound - Unidentified',
          businessUnit: 'ExtraHut'
        })
        await axios.post(process.env.GATSBY_CONTACT_FORM_URL, data)
        return true
      }
      return false
    } catch {
      return false
    }
  }

  static async detectPotentialSpam({action, clientIP, token}: DetectSpamData) {
    if (!clientIP || !process.env.GATSBY_SECURITY_APP) return
    try {
      const data = {
        clientIP,
        action,
        captchaUrl: (action === 'submit' && token) ? `https://www.google.com/recaptcha/api/siteverify?secret=6Ld2rL0kAAAAAMu9_rMrS0HMhPpbzlO9L11OpDSS&response=${token}` : '',
      }
      const res = await axios.post(process.env.GATSBY_SECURITY_APP, data)
      if (res.status === 202) return true
      if (res.status === 200) return false
    } catch (e) {
      return true
    }
  }
}